import { env } from '@/config/env';

/**
 * True khi **không** có `VITE_API_BASE_URL` — không gọi được gateway; UI dùng fallback cục bộ nơi có.
 */
export function shouldUseSampleData(): boolean {
  return env.API_BASE_URL.trim() === '';
}

/**
 * True khi đã cấu `VITE_API_BASE_URL` — cho phép gọi REST vận hành (ops, dashboard, flood-jobs, …).
 */
export function shouldFetchOperationalApi(): boolean {
  return env.API_BASE_URL.trim() !== '';
}
